(($) => {

    /**
     * Adds the attributes to a form hint:
     tabindex="0"
     data-toggle="tooltip"
     data-placement="bottom"
     title="{{ tooltip }}"
     */
    $.fn.formHint = function () {

        return this.each((i, el) => {
            const formHint = $(el);
            formHint.attr('title', formHint.text());
            formHint.text('');
            formHint.tooltip({
                placement: 'bottom',
            });
        });

    };

})(jQuery);
